var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-ad-budget-edit","toptitle":"Budget bearbeiten","title":_vm.projectAdBudget.description,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-ad-budget-form',{attrs:{"projectAdBudget":_vm.projectAdBudget,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }